import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { Message } from './conversation.js';

@Entity()
export class Feedback extends MongoEntity {
  static override _class = 'Feedback';
  static override _collectionName = 'feedback';

  @Field(() => String)
  conversationId: Maybe<string>;

  @Field(() => String)
  messageId: Maybe<string>;

  @Field(() => String)
  vote: Maybe<string>;

  @Field(() => String)
  feedback: Maybe<string>;

  @Field(() => String)
  timestamp: Maybe<string>;

  @Field(() => [Message])
  context: Maybe<Message[]>;
}
